'use client';

import { Button } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';
import { useFormConfigs } from '../FormProvider/FormProvider';
import { useFormContext } from 'react-hook-form';

export const FormButton = ({ children, ...other }: ButtonProps) => {
	const { formState: { isSubmitting, isLoading } } = useFormContext();
	const isDisabled = isSubmitting || isLoading;

	return (
		<Button
			{...other}
			disabled={isDisabled}
			type={'button'}
		>
			{children}
		</Button>
	);
};

export const ResetButton = ({ children, ...other }: ButtonProps) => {
	const { formState: { isSubmitting, isDirty } } = useFormContext();
	const isDisabled = !isDirty || isSubmitting;

	return (
		<Button
			disabled={isDisabled}
			loading={isSubmitting}
			minW={'150px'}
			{...other}
			type={'reset'}
		>{children}
		</Button>
	);
};

export const SubmitButton = ({ children, ...other }: ButtonProps) => {
	const {
		formState: {
			isSubmitting, isDirty, isValid, isLoading,
		},
	} = useFormContext();
	const { disableSubmit } = useFormConfigs();

	const isDisabledOnLoading = disableSubmit.onLoading && isLoading;
	const isDisableOnSubmitting = disableSubmit.onSubmitting && isSubmitting;
	const isDisabledWhenIsNotDirty = disableSubmit.whenIsNotDirty && !isDirty;
	const isDisabledWhenNotValid = disableSubmit.whenNotValid && !isValid;

	const isDisabled = [
		isDisabledOnLoading,
		isDisableOnSubmitting,
		isDisabledWhenIsNotDirty,
		isDisabledWhenNotValid,
	].some(Boolean);

	return (
		<Button
			disabled={isDisabled}
			loading={isSubmitting}
			{...other}
			type={'submit'}
		>
			{children}
		</Button>
	);
};